import { render, staticRenderFns } from "./ValueSelect.vue?vue&type=template&id=3be9c10c"
import script from "./ValueSelect.vue?vue&type=script&lang=js"
export * from "./ValueSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports